import { useEffect, useState } from 'react';
import { getDescriptionForPath } from '../../../../../config/configEntry';
import classes from './DesignColorsSection.module.css';

const ADMIN_COLOR_FIELD_KEYS = [
  'backgroundGradientStart',
  'backgroundGradientEnd',
  'backgroundGradientSidebarStart',
  'backgroundGradientSidebarEnd',
  'headerGradientStart',
  'headerGradientMid',
  'headerGradientEnd',
  'surface',
  'cookiesSurface',
  'primary',
  'iconSendStroke',
  'iconSendFill',
  'onPrimary',
  'userBubbleBackground',
  'userBubbleText',
  'modelBubbleBackground',
  'modelBubbleText',
  'loaderPrimary',
  'loaderSecondary',
  'discoveryButtonBorder',
  'discoveryButtonBackground',
  'discoveryButtonText',
  'sessionItemSelectedBackground',
  'sessionItemDateText',
  'sessionItemTopicText',
  'sendButtonDisabledBackground',
  'messageInputBackground',
  'messageInputBorder',
  'sidebarFooterBorder',
  'sidebarFooterText',
  'sidebarHeaderText',
  'iconCloseStroke',
  'iconDragStroke',
  'iconChatsStroke',
  'iconExpandStroke',
  'iconSidebarCollapseStroke',
  'iconSidebarFooterStroke',
  'authButtonText',
  'iconChatTextStroke',
  'iconNewConversationStroke',
  'greetingText',
];

function colorKeysForDraft(theme) {
  const colorKeys = Object.keys(theme?.colors || {});
  const colorKeySet = new Set(colorKeys);
  const orderedKeys = ADMIN_COLOR_FIELD_KEYS.filter(key => colorKeySet.has(key));
  const extraKeys = colorKeys.filter(key => !ADMIN_COLOR_FIELD_KEYS.includes(key));
  return [...orderedKeys, ...extraKeys];
}

function normalizeHex(val) {
  if (typeof val !== 'string') return '#000000';
  const s = val.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(s)) return s;
  if (/^#[0-9A-Fa-f]{3}$/.test(s)) {
    return ('#' + s[1] + s[1] + s[2] + s[2] + s[3] + s[3]).toLowerCase();
  }
  return '#000000';
}

const DesignColorsSection = ({ draft, setDraft, descriptions }) => {
  const [colorKeys, setColorKeys] = useState([]);

  useEffect(() => {
    setColorKeys(colorKeysForDraft(draft.theme));
  }, [draft.theme]);

  const setColor = (key, value) => {
    setDraft(d => ({
      ...d,
      theme: {
        ...d.theme,
        colors: {
          ...d.theme?.colors,
          [key]: value,
        },
      },
    }));
  };

  return (
    <div className={classes.ColorsGrid}>
      {colorKeys.map(key => {
        const hex = draft.theme?.colors?.[key] ?? '#000000';
        const path = `theme.colors.${key}`;
        const label = getDescriptionForPath(descriptions, key, path);
        return (
          <div key={key} className={classes.Field}>
            <label className={classes.Label} htmlFor={`c-${key}`}>
              {label}
            </label>
            <div className={classes.ColorRow}>
              <input
                id={`c-${key}`}
                type="color"
                className={classes.ColorPicker}
                value={normalizeHex(hex || '#000000')}
                onChange={e => setColor(key, e.target.value)}
              />
              <input
                className={classes.TextInput}
                value={hex}
                placeholder="#"
                onChange={e => setColor(key, e.target.value)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DesignColorsSection;
